/**
 * Iterate Dashboard — content-only component.
 *
 * After the AeroLayout refactor, auth, subscription fetching, sidebar, and
 * GlassProvider all live in AeroLayout. This is a pure content panel.
 */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import GlassTag from '../../components/Aero/GlassTag';
import '../../components/Aero/aero-components.css';
import './IterateDashboard.css';

function IterateDashboard() {
  return (
    <>
      <Helmet>
        <title>Iterate | Aero</title>
        <meta name="description" content="AI-powered design editing for Figma" />
      </Helmet>

      <div className="iterate-content">
        {/* Sparkle icon */}
        <div className="iterate-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M12 2l2.09 6.26H21l-5.47 3.97 2.09 6.26L12 14.52l-5.62 3.97 2.09-6.26L3 8.26h6.91z" />
          </svg>
        </div>

        <h1 className="iterate-title">Iterate</h1>
        <p className="iterate-subtitle">AI-powered design editing for Figma</p>
        <p className="iterate-description">
          Select any frame in Figma, describe what you want changed, and watch it happen.
          Refine colors, adjust layouts, tweak spacing — all through natural language.
        </p>

        <GlassTag>Coming Soon</GlassTag>
      </div>
    </>
  );
}

export default IterateDashboard;
